

















import { Component, Mixins } from "vue-property-decorator";

// Mixins
import CProdInjectorMixin from "@/mixins/cProdInjectorMixin";

// Enums/Data
import { ContractStatusCodes } from "@/models/contracts";
import { ProductTypes } from "@/data/enums/products";

@Component({
  components: {
    "migration-provider": () =>
      import(
        "@/components/app/global/client/contractProducts/migrations/migrationProvider.vue"
      )
  }
})
export default class CProdUpgradeDowngradeButton extends Mixins(
  CProdInjectorMixin
) {
  // Computed

  public get isVisible() {
    return (
      this.cProdData.allowedMigrations.length &&
      !this.cProdData.hasActiveCancellationRequest &&
      !this.cProdData.hasAcceptedCancellationRequest &&
      !this.cProdData.hasAutoExpireEnabled &&
      this.cProdData.product.product_type === ProductTypes.SINGLE_PRODUCT
    );
  }

  public get upgradeDowngradeDisabled() {
    const { contractProduct } = this.cProdData;
    return (
      ![ContractStatusCodes.ACTIVE, ContractStatusCodes.SUSPENDED].includes(
        this.$_.get(contractProduct, "status.code", "")
      ) ||
      contractProduct.pro_rata_pending ||
      this.cProdData.isStaged
    );
  }
}
